module.exports = __webpack_public_path__ + "img/relatus_white_logo.eda38df8.png";